const contracts = [
  { id: "ST", name: "SANS TUBULURE" },
  { id: "STD", name: "SANS TUBULURE DASH" },
  { id: "STMT", name: "ST MEDTRUM TOUCHCARE" },
  { id: "AT", name: "AVEC TUBULURE" },
  { id: "BF MED", name: "BF MEDTRONIC" },
  { id: "BF MEDG4", name: "BF MEDTRONIC G4" },
  { id: "CANL", name: "CAPTEUR EN LITE" },
  { id: "CADXG6", name: "CAPTEUR DEXCOM G6" },
  { id: "CADXG6S", name: "CAPTEUR DEXCOM G6" },
  { id: "SP BF", name: "SUSPENSION MEDTRONIC 780G" },
  { id: "SP ST", name: "SUSPENSION OMNIPOD" },
  { id: "SP STD", name: "SUSPENSION OMNIPOD DASH" },
  { id: "SP AT", name: "SUSPENSION POMPE A INSULINE" },
  { id: "BF CAMAPS", name: "BF YPSOMED CAMAPS" },
  { id: "BF TANDEM", name: "BF TANDEM" },
  { id: "AT MED", name: "AT MEDTRONIC" },
  { id: "AT YPSO", name: "AT YPSOMED" },
  { id: "AT TANDEM", name: "AT TANDEM" },
  { id: "AT BIQ", name: "AT TANDEM BIQ" },
  { id: "AT MED740G", name: "AT MEDTRONIC 740G" },
  { id: "BF DIABELOOP", name: "BF DIABELOOP" },
  { id: "STMT300", name: "ST MEDTRUM TOUCHCARE 300" },
  { id: "BF O5", name: "BF OMNIPOD 5" },
];

export default contracts;
